// extracted by mini-css-extract-plugin
module.exports = {"item":"Index_item__95FYn","name":"Index_name__3mz5W"};